export default "__VITE_ASSET__9504119f__"